import { documentFileUrl, type TeamSeasonDocument } from "./queries/seasonDocuments";
import type { ID } from "./id";

/** Where a season document opens: the page itself for a link, else the PDF. */
export function documentHref(d: TeamSeasonDocument): string {
  return d.url || documentFileUrl(d.version_id);
}

/** Every pending document ticked: the server asks for all of them
 * (seasondoc.CheckTx), so a consent dialog keeps its confirm off until then. */
export function allTicked(documents: TeamSeasonDocument[], ticked: ReadonlySet<ID>): boolean {
  return documents.every((d) => ticked.has(d.version_id));
}
